/* eslint-disable no-console */

import { register } from 'register-service-worker'
import store from './store'

if (process.env.NODE_ENV === 'production') {
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready() {
            console.log(
                'App is being served from cache by a service worker.\n' +
                'For more details, visit https://goo.gl/AFskqB'
            )
        },
        registered() {
            console.log('Service worker has been registered.')
            store.dispatch('inspectToken')
        },
        cached() {
            console.log('Content has been cached for offline use.')
        },
        updatefound() {
            console.log('New content is downloading.')
        },
        updated() {
            console.log('Updated.')
            store.dispatch('setAppUpdateState', true)
            store.dispatch('showNotification', {
                type: 'info',
                message: 'Dostępna jest nowa wersja aplikacji.',
                action: {
                    data: 'reload',
                    label: 'Odśwież'
                },
                timeout: -1
            })
        },
        offline() {
            console.log(
                'No internet connection found. App is running in offline mode.'
            )
        },
        error(error) {
            console.error('Error during service worker registration:', error)
        }
    })
}